import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { TSourceItem } from '@core/interfaces/TSourceItem';

import { TSourceEmbedding } from '@core/api/sources/types';
import { StringUtils } from '@shared/utils/stringUtils';

import { SourceReferencesComponent } from '../../source-references/source-references.component';

@Component({
  selector: 'app-edit-references-modal',
  templateUrl: './edit-references-modal.component.html',
  styleUrls: ['./edit-references-modal.component.scss'],
  standalone: true,
  imports: [
    SourceReferencesComponent,
    MatButton,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIcon,
    MatTooltip,
  ],
})
export class EditReferencesModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { source: TSourceItem; embedding: TSourceEmbedding },
    private dialogRef: MatDialogRef<EditReferencesModalComponent>
  ) {}

  /** Short preview for the dialog; full text in tooltip. */
  protected get previewSnippet(): string {
    const raw = this.data.embedding?.content ?? '';
    const sentence = StringUtils.getFirstSentence(raw) || raw.trim();
    const max = 320;
    if (sentence.length <= max) {
      return sentence || '—';
    }
    return `${sentence.slice(0, max).trim()}…`;
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
